/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetDraftPaymentRequest200ResponseEvidencesInnerErrors
 */
export interface GetDraftPaymentRequest200ResponseEvidencesInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'detectedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'calculatedDpi'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'colorGradation'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'heightMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetDraftPaymentRequest200ResponseEvidencesInnerErrors
     */
    'widthMillis'?: GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum;
}

export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsDetectedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsCalculatedDpiEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsColorGradationEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsHeightMillisEnum];
export const GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum = typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum[keyof typeof GetDraftPaymentRequest200ResponseEvidencesInnerErrorsWidthMillisEnum];


